import { yupResolver } from '@hookform/resolvers/yup';
import { IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import ProfessionalRetailerStyle from './Professional_Retailer.style';
import * as yup from 'yup';
import { RegionDropdown } from 'react-country-region-selector';
import _ from 'lodash';
import api from '@api/Apis';
import { NewYorkPopUp } from '@Components/Common/CommonMethods';
import { EMPLOYEES_NUMBER, RETAIL_BUSINESS, SERVICE_OFFER, SHARE_PLAN_SNiP, SOCIAL_PLATFORMS, WELLNESS_OPIONS } from '@Components/Common/Constents';
import { useRouter } from 'next/router';

const ProfessionalRetailerPopup = (props) => {
    const { open, setOpen, section, plan } = props;

    const [phoneVal, setPhoneVal] = useState(false);
    const [selectState, setSelectState] = useState({ value: "", error: "" });
    const [socialPlatform, setSocialPlatform] = useState("");
    const [checkedValue, setCheckedValue] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [newYorkCheck, setNewyorkCheck] = useState(false);
    const [showForm, setShowForm] = useState(true);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);

    function _repeatedMsg(value, msg = "this field") {
        return ({
            is: () => _.includes(value, section),
            then: yup.string().trim().required(`${msg} is required`),
            otherwise: yup.string().notRequired(),
        });
    };

    const schema = yup.object().shape({
        first_name: yup.string().trim()
            .required('this field is required'),
        last_name: yup.string().trim()
            .required('this field is required'),
        email: yup.string().trim()
            .required('this field is required')
            .email('invalid email'),
        phone_no: yup.string().notRequired(),
        city: yup.string().trim().required('this field is required'),
        comment: yup.string().trim().required('This field is required'),
        website: yup.string().notRequired(),
        professional: yup.string().when([], _repeatedMsg(["professional"])),
        service_plan: yup.string().when([], _repeatedMsg(['professional'])),
        affiliate: yup.string().when([], _repeatedMsg(['affiliate'])),
        retail_business: yup.string().when([], _repeatedMsg(['retailer'])),
        employess_count: yup.string().when([], _repeatedMsg(['employers'])),
        social_platforms: yup.string().when([], _repeatedMsg(["employers", "retailer", "professional", "affiliate"], "this field")),
        company_name: yup.string().when([], _repeatedMsg(['employers'])),
        industry: yup.string().when([], _repeatedMsg(["employes"])),
        number_of_employe: yup.string().when([], _repeatedMsg(["employes"])),
        list: yup.string().when('professional', {
            is: (val) => val === "Other",
            then: yup.string().trim().required("this field is required"),
            otherwise: yup.string().notRequired()
        }),
        listaffiliate: yup.string().when('affiliate', {
            is: (val) => val === "Other – I have a unique approach!",
            then: yup.string().trim().required("this field is required"),
            otherwise: yup.string().notRequired()
        }),
        retailService: yup.string().when('retail_business', {
            is: (val) => val === "Other – Please specify in the box below",
            then: yup.string().trim().required("this field is required"),
            otherwise: yup.string().notRequired()
        }),

        listService: yup.string().when('service_plan', {
            is: (val) => val === "Other – please specify",
            then: yup.string().trim().required("this field is required"),
            otherwise: yup.string().notRequired()
        }),

        specify: yup.string().when('social_platforms', {
            is: (val) => val === "Other (please specify below)" || val === "Event (please specify below)",
            then: yup.string().trim().required("this field is required"),
            otherwise: yup.string().notRequired()
        }),
        news_checkbox: yup.boolean().notRequired(),
        practice_size: yup.string().when([], _repeatedMsg(['professional'])),
        license: yup.string().when([], _repeatedMsg(['professional'])),
        business_name: yup.string().when([], _repeatedMsg(['retailer'])),
    });

    const { register, handleSubmit, errors, setValue, reset, watch } = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
    });

    const professionalValue = watch('professional');
    const socialPlatformValue = watch('social_platforms');
    const affiliateValue = watch('affiliate');
    const Service_Plan = watch('service_plan');
    const Retail_Business_plan = watch('retail_business');

    useEffect(() => {
        setValue('social_platforms', socialPlatform);
    }, [socialPlatform, setValue]);

    const handleSelectChange = (e) => {
        const value = e.target.value;
        setSocialPlatform(value);
    };

    const onSubmit = async (data) => {
        if (!selectState?.value) {
            setSelectState({ ...selectState, error: 'Please select a state.' });
            return;
        }
        if (selectState) {
            data.state = selectState?.value;
            data.form = plan;

            try {
                const response = await api._planServices(data);
                if (response?.status === 200) {
                    setSuccessMsg(response?.data?.message);
                    reset();
                    setCheckedValue();
                    setShowForm(false);
                    setShowSuccessMessage(true);
                }
            } catch (error) {
                throw new Error('Error coming from plan Api in ProfessionalRetailerPopup.');
            }
        }
    };

    function _InputField(fieldName, placeHolder, label = null) {
        return (
            <div className="mb-3 field-class">
                {label && <label htmlFor={fieldName}>{label}</label>}
                <input type="text" className="form-control" name={fieldName} placeholder={placeHolder} ref={register} />
                {errors[fieldName] && <span className="error">{errors[fieldName]?.message}</span>}
            </div>
        );
    };

    return (
        <>
            {open && (
                <ProfessionalRetailerStyle>
                    <div className="left-img"><img src="/images/molecularleft1.png" alt='molecule' loading='lazy' /></div>
                    <div className="right-img"><img src="/images/molecular_right.png" alt='molecule' loading='lazy' /></div>
                    <div className="container">
                        <div className={'professional-form ' + (showSuccessMessage ? 'showSuccessMessage' : '')}>
                            {showForm && (
                                <form className="signupform main-sign-frm" style={{ background: '#5FB5BE' }} onSubmit={handleSubmit(onSubmit)}>
                                    {section === "affiliate" &&
                                        <>
                                            <p className='main-heading-form'>
                                                Interested in Becoming a SNiP Affiliate? Let’s Chat.
                                            </p>
                                            <p className='last-heading-form'> Fill out the form below to tell us more about you and what you’re looking for—we’ll follow up with helpful info and answers
                                                to your questions.</p>
                                        </>
                                    }
                                    {section === "professional" &&
                                        <>
                                            <p className='main-heading-form'>
                                                Want to Learn How SNiP Can Support Your Practice?
                                            </p>
                                            <p className='last-heading-form'> If you’re a licensed or credentialed wellness professional, complete
                                                the form below to ask questions and explore how a partnership
                                                with SNiP could benefit your patients or clients.</p>
                                        </>
                                    }
                                    {section === "retailer" &&
                                        <>
                                            <p className='main-heading-form'>
                                                Curious About Carrying SNiP Products in Your Store or Studio?
                                            </p>
                                            <p className='last-heading-form'> Let us know a bit about your business and what you’d like to learn—we’ll
                                                follow up with details about our retail partnership opportunities.</p>
                                        </>

                                    }
                                    {section === "employers" &&
                                        <>
                                            <p className='main-heading-form'>
                                                Exploring Wellness Options for Your Team? We’re Here to Help.

                                            </p>
                                            <p className='last-heading-form'>
                                                Fill out the form below to tell us about your company and your goals—we’ll get back to you with
                                                information on how SNiP can support employee health and performance.</p>
                                        </>
                                    }

                                    {_InputField('first_name', "First Name*")}
                                    {_InputField('last_name', "Last Name*")}
                                    {_InputField('email', "E-mail*")}
                                    {_InputField('phone_no', "Phone Number")}
                                    {(section === "employers") &&
                                        <>
                                            {_InputField('company_name', "Company name:*")}

                                        </>
                                    }
                                    {section === "retailer" &&
                                        <>
                                            {_InputField('business_name', "Business Name*")}
                                        </>
                                    }
                                    {(section === "affiliate" || section === "retailer" || section === "employers") &&
                                        <>
                                            {_InputField('website', "Website")}
                                        </>
                                    }
                                    {_InputField('city', "City*")}
                                    <div className="mb-3 field-class">
                                        <RegionDropdown
                                            country={'US'}
                                            value={selectState?.value}
                                            name="state"
                                            className="form-control"
                                            valueType="short"
                                            defaultOptionLabel="State*"
                                            countryValueType="short"
                                            onChange={(val) => {
                                                if (val === "NY") { setNewyorkCheck(true) } else { setNewyorkCheck(false) };
                                                setSelectState({ value: val, error: "" });
                                            }}
                                        />
                                        {(selectState?.value === "") && <span className="error">{selectState?.error}</span>}
                                        <NewYorkPopUp open={newYorkCheck} setClose={setNewyorkCheck} />
                                    </div>
                                    {section === "employers" &&
                                        <div className="mb-3 field-class">
                                            <select className="form-control" name="employess_count" placeholder="How do you plan to share SNiP?*" ref={register}>
                                                <option value="">How many employees are in your organization?*</option>
                                                {_.map(EMPLOYEES_NUMBER, (row, index) => <option key={index} value={row}>{row}</option>)}
                                            </select>
                                            {errors.employess_count && <span className="error">{errors.employess_count.message}</span>}
                                        </div>
                                    }

                                    {section === "retailer" &&
                                        <div className="mb-3 field-class">
                                            <select className="form-control" name="retail_business" placeholder="How do you plan to share SNiP?*" ref={register}>
                                                <option value="">What type of retail business do you operate?*</option>
                                                {_.map(RETAIL_BUSINESS, (row, index) => <option key={index} value={row}>{row}</option>)}
                                            </select>
                                            {errors.retail_business && <span className="error">{errors.retail_business.message}</span>}
                                        </div>
                                    }
                                    {Retail_Business_plan === "Other – Please specify in the box below" && _InputField('retailService', "", "If You Select Other Please List*")}

                                    {(section === "affiliate") &&
                                        <>
                                            <div className="mb-3 field-class">
                                                <select className="form-control" name="affiliate" placeholder="How do you plan to share SNiP?*" ref={register}>
                                                    <option value="">How do you plan to share SNiP?*</option>
                                                    {_.map(SHARE_PLAN_SNiP, (row, index) => <option key={index} value={row}>{row}</option>)}
                                                </select>
                                                {errors.affiliate && <span className="error">{errors.affiliate.message}</span>}
                                            </div>

                                            {affiliateValue === "Other – I have a unique approach!" && _InputField('listaffiliate', "", "If You Select Other Please List*")}
                                        </>
                                    }
                                    {(section === "professional") &&
                                        <>
                                            <div className="mb-3 field-class">
                                                <select className="form-control" name="professional" placeholder="Wellness Professional Type*" ref={register}>
                                                    <option value="">Wellness Professional Type*</option>
                                                    {_.map(WELLNESS_OPIONS, (row, index) => <option key={index} value={row}>{row}</option>)}
                                                </select>
                                                {errors.professional && <span className="error">{errors.professional.message}</span>}
                                            </div>

                                            {professionalValue === "Other" && _InputField('list', "", "If You Select Other Please List*")}
                                            {_InputField('license', "License(s) / Certification(s) Type(s)* ")}
                                            {_InputField('practice_size', "Practice size* ")}
                                            <div className="mb-3 field-class">
                                                <select className="form-control" name="service_plan" placeholder="How do you plan to share SNiP?*" ref={register}>
                                                    <option value="">Where do you offer your services?*</option>
                                                    {_.map(SERVICE_OFFER, (row, index) => <option key={index} value={row}>{row}</option>)}
                                                </select>
                                                {errors.service_plan && <span className="error">{errors.service_plan.message}</span>}
                                            </div>
                                            {Service_Plan === "Other – please specify" && _InputField('listService', "", "If You Select Other Please List*")}

                                        </>

                                    }

                                    <div className="mb-3 field-class">
                                        <select
                                            className="form-control"
                                            name="social_platforms"
                                            ref={register}
                                            defaultValue={socialPlatform}
                                            onChange={handleSelectChange}
                                        >
                                            <option value="">How did you hear about SNiP? Please select one of these options:</option>
                                            {_.map(SOCIAL_PLATFORMS, (row, index) => (
                                                <option key={index} value={row}>{row}</option>
                                            ))}
                                        </select>
                                        {errors.social_platforms && <span className="error">{errors.social_platforms.message}</span>}
                                    </div>

                                    {(socialPlatformValue === "Other (please specify below)" || socialPlatformValue === "Event (please specify below)" ||
                                        socialPlatformValue === "Affiliate" || socialPlatformValue === "Wellness provider") &&
                                        _InputField('specify', "", "Please Specify*")
                                    }
                                    {section === "affiliate" &&
                                        <div className="mb-3 field-class">
                                            <label htmlFor="comments">Please specify your interest and any questions you have about becoming an affiliate partner*</label>
                                            <input type='text' className="form-control" name="comment" ref={register} />
                                            {errors.comment && <span className="error">{errors.comment.message}</span>}
                                        </div>
                                    }
                                    {section === "professional" &&
                                        <div className="mb-3 field-class">
                                            <label htmlFor="comments">Please specify your interest and any questions you have about our Wellness Provider program*
                                            </label>
                                            <input type='text' className="form-control" name="comment" ref={register} />
                                            {errors.comment && <span className="error">{errors.comment.message}</span>}
                                        </div>
                                    }
                                    {section === "retailer" &&
                                        <div className="mb-3 field-class">
                                            <label htmlFor="comments">Please specify your interest and any questions you have about carrying SNiP products*
                                            </label>
                                            <input type='text' className="form-control" name="comment" ref={register} />
                                            {errors.comment && <span className="error">{errors.comment.message}</span>}
                                        </div>
                                    }
                                    {section === "employers" &&
                                        <div className="mb-3 field-class">
                                            <label htmlFor="comments">Please specify your interest and any questions you have about bringing SNiP to your team*
                                            </label>
                                            <input type='text' className="form-control" name="comment" ref={register} />
                                            {errors.comment && <span className="error">{errors.comment.message}</span>}
                                        </div>
                                    }
                                    <div className="mb-3 field-class d-flex">
                                        <input type='checkbox' ref={register} name="news_checkbox" /> Opt in to SNIP news
                                    </div>


                                    <div className="mb-0 mt-3 field-class">
                                        <button type="submit" className=" btn-primary">Submit</button>
                                    </div>
                                </form>
                            )}

                            {showSuccessMessage && <div className='success'><p>{successMsg}</p></div>}
                        </div>
                    </div>
                </ProfessionalRetailerStyle>
            )}
        </>
    );
};

export default ProfessionalRetailerPopup;
